import React from "react";

import { Button, Col, Row } from "react-bootstrap";
import { ButtonsContainer } from "../../IncidentReportForm";
import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import { SearchableSelect } from "app/Components/SearchableSelect/SSingleSelect";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

function EquipmentDetailsTab({
  form = {},
  onChange,
  error = {},
  setTab,
  onSubmit,
  assetDetails,
  matDetails,
  onChangeAssetDetailsSku,
  onChangeAssetDetailsSkuInput,
  mats,
  assetDetailsErrors,
  onChangeAssetDetails,
  deleteRowAssetDetails,
  addRowAssetDetails,
}) {
  return (
    <div className="card p-3 pb-0 mt-3">
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">Equipment Details</h3>
      </div>
      <div className="ehsFormWrapper">
        <Row className="mb-4 justify-content-start align-items-center">
          <Col lg={4}>
            <YesOrNo
              title="Equipment Affected"
              name="isAssetIncident"
              value={form.isAssetIncident === null ? false : form.isAssetIncident}
              onChange={onChange}
            />
            <span className="small text-danger">{error?.isAssetIncident}</span>
          </Col>
        </Row>
        {form.isAssetIncident && (
          <div className="w-100">
            <div className="table-responsive">
              <table className="table table-bordered mb-3">
                <thead>
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Equipment Type</th>
                    <th scope="col">Equipment SKU / Id</th>
                    <th scope="col">Equipment Name</th>
                    <th scope="col">Equipment Incident Details</th>
                    <th scope="col">Equipment Damage (Y/N)</th>
                    <th scope="col">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {assetDetails.length ? (
                    assetDetails.map((x, index) => {
                      return x.deleted ? null : (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <td>
                            <SearchableSelect
                              name="type"
                              options={matDetails.map((obj) => ({
                                label: obj.name,
                                value: obj.id,
                              }))}
                              value={+x.type}
                              onChange={({ target: { name, value } }) =>
                                onChangeAssetDetails(index, name, value)
                              }
                            />
                            <span className="small text-danger">
                              {assetDetailsErrors[index]?.sku}
                            </span>
                          </td>
                          <td>
                            <input
                              name="sku"
                              value={x.sku}
                              onChange={({ target: { name, value } }) =>
                                onChangeAssetDetails(index, name, value)
                              }
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {assetDetailsErrors[index]?.name}
                            </span>
                          </td>
                          <td>
                            <input
                              name="name"
                              value={x.name}
                              onChange={({ target: { name, value } }) =>
                                onChangeAssetDetails(index, name, value)
                              }
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {assetDetailsErrors[index]?.details}
                            </span>
                          </td>
                          <td>
                            <input
                              name="details"
                              value={x.details}
                              onChange={({ target: { name, value } }) =>
                                onChangeAssetDetails(index, name, value)
                              }
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {assetDetailsErrors[index]?.details}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex">
                              <label className="radio radio-primary form-check-inline mr-3">
                                <input
                                  onChange={({ target: { name, value } }) =>
                                    onChangeAssetDetails(index, name.split("-")[0], value)
                                  }
                                  type="radio"
                                  name={`damage-${index}`}
                                  value="Yes"
                                  checked={x.damage === "Yes"}
                                />
                                <span>Yes</span>
                                <span className="checkmark" />
                              </label>
                              <label className="radio radio-primary form-check-inline mr-3">
                                <input
                                  onChange={({ target: { name, value } }) =>
                                    onChangeAssetDetails(index, name.split("-")[0], value)
                                  }
                                  type="radio"
                                  name={`damage-${index}`}
                                  value="No"
                                  checked={x.damage === "No"}
                                />
                                <span>No</span>
                                <span className="checkmark" />
                              </label>
                            </div>
                          </td>
                          <td>
                            <div className="actionIconsGroup">
                              {/* <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">Delete</Tooltip>
                                }
                              >
                                <a
                                  href
                                  className="icons text-danger pointer font-20"
                                  onClick={() => deleteRowAssetDetails(index)}
                                >
                                  <FiMinusCircle />
                                </a>
                              </OverlayTrigger> */}
                              <CustomTooltip tooltip={"Delete"}>
                                <a
                                  href
                                  className="icons text-danger pointer font-20"
                                  onClick={() => deleteRowAssetDetails(index)}
                                >
                                  <FiMinusCircle />
                                </a>
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" align="center">
                        {/* <div className="alert alert-danger d-inline-block m-0">
                                                            <strong>Empty</strong>
                                                        </div> */}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan="10">
                      {/* <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                      >
                        <Button
                          className="addRowPluseIcon"
                          onClick={addRowAssetDetails}
                        >
                          <FiPlusCircle />
                        </Button>
                      </OverlayTrigger> */}
                      <CustomTooltip tooltip={"Add Row"}>
                        <Button className="addRowPluseIcon" onClick={addRowAssetDetails}>
                          <FiPlusCircle />
                        </Button>
                      </CustomTooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        prev={3}
        next={5}
        closeIncident={form.closeIncident}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default EquipmentDetailsTab;
